import axios from 'axios';
import React, { useContext, useEffect, useMemo, useState, useRef } from 'react'
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import authContext from '../context/authContext/authContext';
import RenderError from '../utils/RenderError';
import errorHandle from '../utils/errorHandle';
import successHandle from '../utils/successHandle';
import Loader from '../utils/Loader';

const BECOME_PARTNER_ENDPOINT = process.env.REACT_APP_API_URL + "/api/user/becomePartner";
const CHECK_PARTNER_STATUS_ENDPOINT = process.env.REACT_APP_API_URL + "/api/user/checkPartnerStatus";

const EMAIL_REGEX_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const MOBILE_NUMBER_REGEX_PATTERN = /^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/;
const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!^%*?&]{8,15}$/;
const PASSWORD_STRENGTH = {
  1: "Very weak",
  2: "Weak",
  3: "Meduim",
  4: "Strong",
}

const BecomePartner = () => {
  const navigate = useNavigate()
  const { user, setUser, getConfig, logout } = useContext(authContext);
  const config = getConfig();
  const intialState = { ...user, loading: false, hasDemateAccount: false }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))
  const effectRan = useRef(false);


  const checkPartnershipStatus = async () => {
    if (state.loading) {
      return;
    }

    setState({ loading: true });
    await axios.get(CHECK_PARTNER_STATUS_ENDPOINT, config)
      .then((res) => {
        const { message, isRegistered } = res.data;
        successHandle(message)
        setState({ loading: false, isRegistered });
      })
      .catch((err) => {
        setState({ loading: false });
        errorHandle(err)
      })
  }

  useEffect(() => {
    if (!effectRan.current) {
      checkPartnershipStatus();

      return () => {
        effectRan.current = true;
      }
    }
  }, [])

  const validateName = () => {
    if (!state.name) {
      setState({ nameError: '*Enter name' });
    }
  }

  const validateEmail = () => {
    const isValidEmail = EMAIL_REGEX_PATTERN.test(state.email);
    if (!isValidEmail) {
      setState({ emailError: '*Please enter a valid email!' })
    }
  }

  const validatePhoneNumber = () => {
    if (!state.phone || !MOBILE_NUMBER_REGEX_PATTERN.test(state.phone)) {
      setState({ phoneError: '*Provide valid indian numbers' })
    }
  }

  const validateAddress = () => {
    if (!state?.address) {
      setState({ addressError: '*Provide valid address!' })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setState({ invalidError: '' })
    becomePartner();
  }

  const becomePartner = async () => {
    setState({ loading: true });
    const { name, nameError, phone, clientId, phoneError, email, emailError, address, addressError } = state;
    const isValid = name && email && phone && address && clientId && !nameError && !emailError && !phoneError && !addressError;

    if (!isValid) {
      setState({ invalidError: "*Please provide all the fileds", loading: false })
      return;
    }

    const data = { name, phone, email, address, clientId }
    await axios.post(BECOME_PARTNER_ENDPOINT, data, config)
      .then((res) => {
        setState({ loading: false, isRegistered: true });
        successHandle(res.data.message)
      })
      .catch((err) => {
        setState({ loading: false });
        errorHandle(err)
      })
  }

  const isRegistered = useMemo(() => {
    return state.isRegistered;
  }, [state.isRegistered])

  return (
    <div className='edit-profile-form container mb-5'>
      <div className='container pt-3'>
        <div className='pt-5'>
          <div className='section-title mt-5'>
            <p>Become Partner</p>
            <div className=''>Unlock growth by partnering with us through a rewarding program offering shared opportunities, strong support, steady earnings, and long-term financial success together.</div>
          </div>
          <div className='text-center mb-4' hidden={!state.loading}>
            <Loader isLoading={state.loading} />
          </div>
          <form className={`${isRegistered ? 'disabled' : ''}`} onSubmit={handleSubmit} disabled>
            <div className='row'>
              <div className='col-md-6'>
                <div class="form-group mb-3">
                  <label className='mb-1' for="exampleInputEmail1">Name</label>
                  <input
                    type="name"
                    class="form-control"
                    id="exampleInputName1"
                    aria-describedby="emailHelp"
                    placeholder="Enter name"
                    value={state?.name}
                    onChange={(e) => setState({ name: e.target.value })}
                    onFocus={() => setState({ nameError: '' })}
                    onBlur={validateName}
                    disabled={state.loading}
                  />
                  <RenderError error={state.nameError} />
                </div>
              </div>
              <div className='col-md-6'>
                <div class="form-group mb-3">
                  <label className='mb-1' for="exampleInputEmail1">Contact number</label>
                  <input
                    type="text"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="+91XXXXXXXXXX"
                    value={state?.phone}
                    onChange={(e) => setState({ phone: e.target.value })}
                    onFocus={() => setState({ phoneError: '' })}
                    onBlur={validatePhoneNumber}
                    disabled={state.loading}
                  />
                  <RenderError error={state.phoneError} />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div class="form-group mb-3">
                  <label className='mb-1' for="exampleInputEmail1">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Enter email"
                    value={state?.email}
                    onChange={(e) => setState({ email: e.target.value })}
                    onFocus={() => setState({ emailError: '' })}
                    onBlur={validateEmail}
                    disabled={state.loading}
                  />
                  <RenderError error={state.emailError} />
                </div>
              </div>
              <div className='col-md-6'>
                <div class="form-group mb-3">
                  <label className='mb-1' for="exampleInputEmail1">Address</label>
                  <input
                    type="text"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter address"
                    value={state?.address}
                    onChange={(e) => setState({ address: e.target.value })}
                    onFocus={() => setState({ addressError: '' })}
                    onBlur={validateAddress}
                    disabled={state.loading}
                  />
                  <RenderError error={state.addressError} />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 my-4'>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" onChange={() => setState({ hasDemateAccount: !state.hasDemateAccount })} />
                  <label class="form-check-label" for="exampleCheck1">Already have a demate account ?</label>
                </div>
              </div>
              <div className='col-md-6' hidden={!state.hasDemateAccount}>
                <div class="form-group">
                  <label for="exampleInputEmail1">Client Id</label>
                  <input
                    type="text"
                    class="form-control"
                    onChange={(e) => setState({ clientId: e.target.value })}
                  />
                  <small class="form-text text-muted">We'll verify your account by client id</small>
                </div>
              </div>
            </div>
            <div className=''>
              <button type="submit" class="btn btn-primary w-100" disabled={state.loading || !state.hasDemateAccount || !state.clientId} onClick={handleSubmit}>Submit</button>
            </div>
            <div className='text-center mt-3'>
              <RenderError error={state.invalidError} />
            </div>
          </form>
        </div>

      </div>

    </div>
  )
}

export default BecomePartner
